import { UpdateStamp } from './UpdateStamp'

export class SubQuesResponseAttachment extends UpdateStamp{
    SubQuesResponseAttachmentId: number
    AzureFileId: number
    SubQuesResponseId: number
    SubQuesResponse: Response
}